import React, { useEffect, useState } from 'react';
import Styles from './styles.module.sass';
import { useHistory } from 'react-router-dom'
import { decodeStorage, removeStorage } from 'functions/storageBase64'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import MainLayout from 'newComponents/Layout/MainLayout';
import CreditoLayout from 'newComponents/Layout/CreaditoLayout';
import SectionLayout from 'newComponents/Layout/SectionLayout';

export default function ThankYouPage() {
    const history = useHistory()
    const payCodeSuccess = decodeStorage('payCodeSuccess')
    const [ data, setData ] = useState()
    
    useEffect(()=>{
        // window.ineum('page', 'Thanks Page Credit-Page')
        // window.ineum('meta', 'portal', 'Credito')
        
        if(payCodeSuccess){
            removeStorage('payCardRelation')
        }else{
            history.replace(BASE_PATH)
        }
    },[])
    
    const handleFinalizar = () => {
        removeStorage('payCodeSuccess')
        history.replace(BASE_PATH)
    };

    let codigo = payCodeSuccess;

    return (
        <MainLayout>
            <CreditoLayout setData={setData} >
                <SectionLayout title="PAGAR TARJETA" >
                    <div className={Styles?.contArrayCards}>
                        <div className={Styles?.headThanks}>
                            <p>PAGO EXITOSO</p>
                        </div>
                    
                        <div className={Styles?.contenedorGeneral}>

                            <div className={Styles?.thankBox}>
                                <div className={Styles?.boxLogo}>
                                    <img src={`${BASE_PATH}${SUB_DIRECTORY}img/group25.png`}></img>
                                </div>

                                <div className={Styles?.boxTitle}>
                                    <h4>¡Gracias!</h4>
                                    <h4>Tu pago se realizo con éxito</h4>
                                    <p>Se verá reflejado en un máximo de 48 hrs. Puede darle seguimiento en el banco con el siguiente número de autorización.</p>
                                </div>

                                <div className={Styles?.boxCode}>
                                    <p>{codigo}</p>
                                </div>

                            </div>
                        </div>
                    </div>
                    
                    <div className={Styles?.boxBtnFinalizar}>
                        <button onClick={handleFinalizar}>Finalizar</button>
                    </div>

                </SectionLayout>
            </CreditoLayout>
        </MainLayout>   
    )
}